module.exports = __webpack_public_path__ + "img/intr.8e50090f.png";